import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../js/coreRuntime.mjs';
import {
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import {
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
} from '../js/charSequenceJs.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from './stringJs.mjs';
import {
  toString3dhdjl9yf50de as toString_0,
  _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx,
} from '../Char.mjs';
import { toString30pk9tzaqopn as toString_1 } from '../Library.mjs';
import { Companion_instance1a0yry1hi33tg as Companion_instance } from '../collections/AbstractList.mjs';
import { CharSequence1ceii1xorfwh7 as CharSequence } from '../CharSequence.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringBuilderClass;
function StringBuilder() {
  if (StringBuilderClass === VOID) {
    class $ {
      static ug(content) {
        var $this = createThis(this);
        $this.p1_1 = content;
        return $this;
      }
      static yb(capacity) {
        return this.q1();
      }
      static q1() {
        return this.ug('');
      }
      a() {
        // Inline function 'kotlin.js.asDynamic' call
        return this.p1_1.length;
      }
      b(index) {
        // Inline function 'kotlin.text.getOrElse' call
        var this_0 = this.p1_1;
        var tmp;
        if (0 <= index ? index <= (charSequenceLength(this_0) - 1 | 0) : false) {
          tmp = charSequenceGet(this_0, index);
        } else {
          throw IndexOutOfBoundsException().n3('index: ' + index + ', length: ' + this.a() + '}');
        }
        return tmp;
      }
      c(startIndex, endIndex) {
        return substring(this.p1_1, startIndex, endIndex);
      }
      t1(value) {
        this.p1_1 = this.p1_1 + toString_0(value);
        return this;
      }
      t2(value) {
        this.p1_1 = this.p1_1 + toString_1(value);
        return this;
      }
      vg(value, startIndex, endIndex) {
        return this.wg(value == null ? 'null' : value, startIndex, endIndex);
      }
      x1(value) {
        this.p1_1 = this.p1_1 + toString_1(value);
        return this;
      }
      xg(value) {
        this.p1_1 = this.p1_1 + value;
        return this;
      }
      yg(value) {
        return this.r1(value.toString());
      }
      zg(value) {
        return this.r1(value.toString());
      }
      r1(value) {
        var tmp = this;
        var tmp_0 = this.p1_1;
        tmp.p1_1 = tmp_0 + (value == null ? 'null' : value);
        return this;
      }
      ah(index, value) {
        Companion_instance.e7(index, this.a());
        this.p1_1 = substring(this.p1_1, 0, index) + toString_0(value) + substring_0(this.p1_1, index);
        return this;
      }
      bh(newLength) {
        if (newLength < 0) {
          throw IllegalArgumentException().s2('Negative new length: ' + newLength + '.');
        }
        if (newLength <= this.a()) {
          this.p1_1 = substring(this.p1_1, 0, newLength);
        } else {
          var inductionVariable = this.a();
          if (inductionVariable < newLength)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              this.p1_1 = this.p1_1 + toString_0(_Char___init__impl__6a9atx(0));
            }
             while (inductionVariable < newLength);
        }
      }
      toString() {
        return this.p1_1;
      }
      ch() {
        this.p1_1 = '';
        return this;
      }
      dh(index) {
        Companion_instance.n7(index, this.a());
        this.p1_1 = substring(this.p1_1, 0, index) + substring_0(this.p1_1, index + 1 | 0);
        return this;
      }
      wg(value, startIndex, endIndex) {
        var stringCsq = toString(value);
        Companion_instance.eh(startIndex, endIndex, stringCsq.length);
        this.p1_1 = this.p1_1 + substring(stringCsq, startIndex, endIndex);
        return this;
      }
    }
    initMetadataForClass($, 'StringBuilder', $.q1, VOID, [CharSequence()]);
    StringBuilderClass = $;
  }
  return StringBuilderClass;
}
//region block: exports
export {
  StringBuilder as StringBuildermazzzhj6kkai,
};
//endregion

//# sourceMappingURL=StringBuilderJs.mjs.map
